import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const FechaAdquisicionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-centroCosto', e, {
      timeOutTime: 200
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label
        text='FEC ADQUISICION'
        htmlFor='inputDate-fechaAdquisicion'
        md={5}
        alignRightAt='md'
      />
      <Col md={7}>
        <Field name='fechaAdquisicion'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='inputDate-fechaAdquisicion'
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaAdquisicionFormGroup)
